/**
 * Front-end JavaScript
 *
 * The JavaScript code you place here will be processed by esbuild. The output
 * file will be created at `../theme/js/script.min.js` and enqueued in
 * `../theme/functions.php`.
 *
 * For esbuild documentation, please see:
 * https://esbuild.github.io/
 */
/**
 * Registration form - add class to form based on "I am a" selection
 */
document.addEventListener('DOMContentLoaded', function() {
	const regForm = document.getElementById('omn-registration-form');
	const iamaRadios = document.querySelectorAll('input[name="iama"]');

	// Check if form exists before proceeding
	if (!regForm || iamaRadios.length === 0) {
		return;
	}

	iamaRadios.forEach(radio => {
		radio.addEventListener('change', function() {
			// Remove any existing iama classes
			regForm.classList.remove('audience-iama-patient', 'audience-iama-caregiver');

			// Add the class based on the selected value
			if (this.checked) {
				regForm.classList.add('audience-iama-' + this.value.toLowerCase());
			}
		});
	});
});

/**
 * Clear individual field errors when user interacts with field
 */
document.addEventListener('DOMContentLoaded', function() {
	const regForm = document.getElementById('omn-registration-form');
	if (!regForm) {
		return;
	}

	// Add event listeners to all form inputs to clear errors on interaction
	const allInputs = regForm.querySelectorAll('input, textarea');
	allInputs.forEach(input => {
		const clearFieldError = function() {
			// Remove error class from the field
			if (input.classList.contains('omn-field-error')) {
				input.classList.remove('omn-field-error');
				
				// Get the field name
				const fieldName = input.name || input.id;
				if (fieldName) {
					// Clear the error message for this field
					const errorMessage = regForm.querySelector(`.form-error-message[data-field="${fieldName}"]`);
					if (errorMessage) {
						errorMessage.classList.remove('show');
						errorMessage.textContent = '';
					}
				}
			}
		};

		input.addEventListener('input', clearFieldError);
		input.addEventListener('change', clearFieldError);
		input.addEventListener('keyup', clearFieldError);
	});
});

/**
 * Registration form submission handler
 * Submits form data to Pulsehealth via WordPress REST proxy
 */
document.addEventListener('DOMContentLoaded', function() {
	let currentForm = document.getElementById('omn-registration-form');
	let submitButton = document.getElementById('omn-submit-btn');
	let ready = true;

	/** No WP page at this path — forces theme 404.php (temporary error UX). */
	const PPZMS_REG_FAILURE_404_PATH = '/zz-ppzms-registration-error/';
	const PPZMS_REG_DEBUG_STORAGE_KEY = 'ppzms_registration_debug';

	/**
	 * Persist debug info so it survives the redirect (new document replays it in 404.php).
	 *
	 * @param {string} reason Human-readable cause.
	 * @param {Record<string, unknown>} extra HTTP status, parsed JSON, etc.
	 */
	function ppzmsRegistrationGoTo404Fallback(reason, extra) {
		const snapshot = Object.assign(
			{
				reason: reason,
				savedAt: new Date().toISOString(),
				fallbackPath: PPZMS_REG_FAILURE_404_PATH
			},
			extra || {}
		);
		try {
			sessionStorage.setItem(PPZMS_REG_DEBUG_STORAGE_KEY, JSON.stringify(snapshot));
		} catch (err) {
			console.warn('[ppzms registration] sessionStorage unavailable:', err);
		}
		console.warn(
			'[ppzms registration] Redirecting to 404 fallback. Debug snapshot saved — open Console on the next page to see "[ppzms registration] Replay…".',
			snapshot
		);
		window.location.href = PPZMS_REG_FAILURE_404_PATH;
	}

	// Check if form elements exist before attaching event listeners
	if (!currentForm || !submitButton) {
		return;
	}

	// Confirm theme script loaded (check Console on any page with the form).
	console.info('[ppzms registration] Script ready — submit is handled via form "submit" (click + Enter).');

	// Enforce numeric-only input for zip code (5 digits)
	const zipcodeInput = currentForm.querySelector('input[name="zipcode"]');
	if (zipcodeInput) {
		zipcodeInput.addEventListener('input', function(e) {
			e.target.value = e.target.value.replace(/[^\d]/g, '').slice(0, 5);
		});
	}

	// Enforce numeric-only input for phone number (up to 14 chars with formatting)
	const phoneInput = currentForm.querySelector('input[name="phone"]');
	if (phoneInput) {
		phoneInput.addEventListener('input', function(e) {
			e.target.value = e.target.value.replace(/[^\d]/g, '').slice(0, 10);
		});
	}

	/**
	 * Lightweight client-side validation to prevent avoidable round-trips.
	 * Server-side validation remains the source of truth.
	 */
	function validateForm() {
		const errors = {};
		const iama = currentForm.querySelector('input[name="iama"]:checked');
		const terms = currentForm.querySelector('input[name="terms"]');
		const fname = currentForm.querySelector('input[name="fname"]');
		const lname = currentForm.querySelector('input[name="lname"]');
		const email = currentForm.querySelector('input[name="email"]');
		const phone = currentForm.querySelector('input[name="phone"]');
		const zipcode = currentForm.querySelector('input[name="zipcode"]');

		if (!iama) {
			errors.iama = '1';
		}
		if (!terms || !terms.checked) {
			errors.terms = '1';
		}
		if (!fname || !String(fname.value || '').trim()) {
			errors.fname = '1';
		}
		if (!lname || !String(lname.value || '').trim()) {
			errors.lname = '1';
		}

		const emailVal = String((email && email.value) || '').trim();
		if (!emailVal) {
			errors.email = 'empty';
		} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
			errors.email = 'invalid';
		}

		const zipVal = String((zipcode && zipcode.value) || '').trim();
		if (!/^\d{5}$/.test(zipVal)) {
			errors.zipcode = '1';
		}

		const phoneVal = String((phone && phone.value) || '').trim();
		if (phoneVal) {
			const digits = phoneVal.replace(/\D/g, '');
			const normalized = (digits.length === 11 && digits.startsWith('1')) ? digits.slice(1) : digits;
			if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(normalized)) {
				errors.phone = '1';
			}
		}

		// Clear previous error classes and messages
		document.querySelectorAll('.omn-field-error').forEach(el => {
			el.classList.remove('omn-field-error');
		});
		
		// Clear all error messages
		document.querySelectorAll('.form-error-message').forEach(el => {
			el.classList.remove('show');
			el.textContent = '';
		});

		// Apply error classes and messages for invalid fields
		for (const key in errors) {
			// Handle radio buttons and checkboxes specially - select all with that name
			if (key === 'iama' || key === 'terms') {
				const inputs = currentForm.querySelectorAll("input[name='" + key + "']");
				inputs.forEach(input => {
					input.classList.add('omn-field-error');
				});
			} else {
				const input = currentForm.querySelector("input[name='" + key + "']");
				if (input) {
					input.classList.add('omn-field-error');
				}
			}
			
			// Populate error message
			const errorMessage = currentForm.querySelector(`.form-error-message[data-field="${key}"]`);
			if (errorMessage) {
				// Define error messages for each field
				let message = 'This field is invalid.';
				if (key === 'email' && errors[key] === 'empty') {
					message = 'This field is required.';
				} else if (key === 'email' && errors[key] === 'invalid') {
					message = 'Please enter a valid email address.';
				} else {
					const messages = {
						iama: 'You must make a selection.',
						fname: 'This field is required.',
						lname: 'This field is required.',
						phone: 'Please enter a valid phone number.',
						zipcode: 'This field is required.',
						terms: 'You must agree to the terms above and certify that you are 18 years or older to continue.'
					};
					message = messages[key] || 'This field is invalid.';
				}
				errorMessage.textContent = message;
				errorMessage.classList.add('show');
			}
		}

		if (Object.keys(errors).length > 0) {
			console.warn('[ppzms registration] Client-side validation failed:', errors);
			const firstError = document.querySelector('.omn-field-error');
			if (firstError && firstError.parentElement) {
				firstError.parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}
			return false;
		}

		return true;
	}

	/**
	 * Use form "submit", not button "click": Enter in a field fires submit but not
	 * the button click; without this, the browser does a full document navigation
	 * and none of our fetch / console logging runs.
	 */
	currentForm.addEventListener('submit', function(e) {
		e.preventDefault();
		e.stopPropagation();

		if (!ready) {
			console.warn('[ppzms registration] Submit ignored (already processing).');
			return;
		}
		ready = false;

		// Validate form before submission
		if (!validateForm()) {
			ready = true;
			submitButton.innerHTML = 'Sign up';
			return;
		}

		submitButton.innerHTML = 'Processing...&nbsp;<span class="loader"></span>';

		// Serialize form data
		const formData = new FormData(currentForm);
		const serializedFormData = new URLSearchParams(formData).toString();
		const fieldNames = Array.from(formData.keys());

		console.log('[ppzms registration] Submit start → POST /wp-json/ppzms/v1/registration');
		console.log('[ppzms registration] Form field names:', fieldNames);

		fetch('/wp-json/ppzms/v1/registration', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: serializedFormData
			})
			.then(response => {
				console.log('[ppzms registration] HTTP response:', {
					status: response.status,
					ok: response.ok,
					statusText: response.statusText
				});
				return response.json().then(data => ({ response, data }));
			})
			.then(({ response, data }) => {
				console.log('[ppzms registration] Parsed JSON:', data);

				// WordPress REST errors use { code, message, data: { status } } — no top-level status.
				if (data && data.code && typeof data.status === 'undefined') {
					console.error('[ppzms registration] WordPress REST error shape:', {
						code: data.code,
						message: data.message,
						data: data.data
					});
					submitButton.innerHTML = 'Sign up';
					ready = true;
					ppzmsRegistrationGoTo404Fallback('REST route or server error (see code/message above)', {
						httpStatus: response.status,
						data: data
					});
					return;
				}

				const resp_status = data['status'];
				const resp_message = data['message'];
				console.log('[ppzms registration] Branch:', {
					resp_status,
					resp_message_type: typeof resp_message,
					resp_message_is_object: resp_message && typeof resp_message === 'object'
				});

				if (resp_status != 200) { // error
					submitButton.innerHTML = 'Sign up';
					ready = true;

					switch (resp_status) {
						case '500':
							console.error('[ppzms registration] Server/config/transport failure (status 500):', resp_message);
							ppzmsRegistrationGoTo404Fallback('application status 500', {
								httpStatus: response.status,
								data: data
							});
							return;

						case 'invalid_post_data':
							console.warn('[ppzms registration] Validation failed; fields:', resp_message);
							// Clear previous errors
							document.querySelectorAll('.omn-field-error').forEach(el => {
								el.classList.remove('omn-field-error');
							});
							
							// Clear all error messages
							document.querySelectorAll('.form-error-message').forEach(el => {
								el.classList.remove('show');
								el.textContent = '';
							});

							// Define field-specific error messages
							const fieldMessages = {
								iama: 'You must make a selection',
								fname: 'This field is required',
								lname: 'This field is required',
								phone: 'Please enter a valid phone number',
								zipcode: 'This field is required',
								terms: 'You must agree to the terms above and certify that you are 18 years or older to continue.'
							};

							for (const key in resp_message) {
								// Apply error class to fields
								if (key === 'terms') {
									const inputs = document.querySelectorAll("input[name='" + key + "']");
									inputs.forEach(input => {
										input.classList.add('omn-field-error');
									});
								} else {
									const input = document.querySelector("input[name='" + key + "']");
									if (input) {
										input.classList.add('omn-field-error');
									}
								}
							
								// Populate error message with field-specific or fallback message
								const errorMessage = currentForm.querySelector(`.form-error-message[data-field="${key}"]`);
								if (errorMessage) {
									// Special handling for email field
									let displayMessage;
									if (key === 'email') {
										if (resp_message[key] === 'empty') {
											displayMessage = 'This field is required.';
										} else if (resp_message[key] === 'invalid') {
											displayMessage = 'Please enter a valid email address';
										} else {
											displayMessage = resp_message[key] || 'This field is invalid';
										}
									} else {
										// Use field-specific message first, then server message, then generic
										displayMessage = fieldMessages[key] || resp_message[key] || 'This field is invalid';
									}
									errorMessage.textContent = Array.isArray(displayMessage) ? displayMessage[0] : displayMessage;
									errorMessage.classList.add('show');
								}
							}

							// Scroll to first error
							const firstError = document.querySelector('.omn-field-error');
							if (firstError && firstError.parentElement) {
								firstError.parentElement.scrollIntoView({behavior: "smooth", block: "center"});
							}

							break;

						case '404':     // no break by intention
						default:
							console.error('[ppzms registration] Upstream failure or unknown status:', resp_status, resp_message);
							ppzmsRegistrationGoTo404Fallback('application status ' + String(resp_status), {
								httpStatus: response.status,
								data: data
							});
							return;
					}
				} else {    // all is well
					console.log('[ppzms registration] Success; redirecting…', resp_message);
					document.querySelectorAll('.omn-field-error').forEach(el => {
						el.classList.remove('omn-field-error');
					});

					if ('Thank you hcap' == resp_message) {
						window.location.href = "/welcome/";
						return;
					} else {
						window.location.href = "/thank-you/";
						return;
					}
				}
			})
			.catch(error => {
				submitButton.innerHTML = 'Sign up';
				ready = true;
				console.error('[ppzms registration] Network or JSON parse error:', error);
				ppzmsRegistrationGoTo404Fallback('fetch/json failure', {
					errorMessage: error && error.message ? String(error.message) : String(error)
				});
			});
	});
});

/**
 * Residents Gate Modal
 * Shows modal on page load if cookie not set, allows users to confirm resident status
 */
document.addEventListener('DOMContentLoaded', function() {
	const modal = document.getElementById('residents-gate-modal');
	const confirmBtn = document.getElementById('residents-confirm');
	const COOKIE_NAME = 'residents_acknowledged';
	const COOKIE_EXPIRY_DAYS = 365;

	// Helper function to get cookie value
	function getCookie(name) {
		const nameEQ = name + "=";
		const cookies = document.cookie.split(';');
		for (let i = 0; i < cookies.length; i++) {
			let cookie = cookies[i].trim();
			if (cookie.indexOf(nameEQ) === 0) {
				return cookie.substring(nameEQ.length);
			}
		}
		return null;
	}

	// Helper function to set cookie
	function setCookie(name, value, days) {
		const date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		const expires = "expires=" + date.toUTCString();
		document.cookie = name + "=" + value + ";" + expires + ";path=/";
	}

	// Only show modal if cookie is not set
	if (modal && !getCookie(COOKIE_NAME)) {
		modal.classList.add('is-visible');

		// Confirm resident button
		if (confirmBtn) {
			confirmBtn.addEventListener('click', function(e) {
				e.preventDefault();
				// Set cookie for 365 days
				setCookie(COOKIE_NAME, 'true', COOKIE_EXPIRY_DAYS);
				// Hide modal
				modal.classList.remove('is-visible');
			});
		}
	}
});

/**
 * Form scroll/navigation handler
 * Scrolls to .pap-form-section if available, otherwise navigates to home and scrolls
 */
document.addEventListener('DOMContentLoaded', function() {
	const formScrollTriggers = document.querySelectorAll('.scroll-to-form');

	formScrollTriggers.forEach(button => {
		button.addEventListener('click', function(e) {
			const formSection = document.querySelector('.pap-form-section');

			// Close mobile menu if it's open (do this first, non-blocking)
			const mobileMenu = document.querySelector('[data-mobile-menu]');
			if (mobileMenu && mobileMenu.classList.contains('is-open')) {
				mobileMenu.classList.remove('is-open');
				const overlay = document.querySelector('[data-mobile-menu-overlay]');
				if (overlay) {
					overlay.classList.remove('is-open');
				}
				const toggle = document.querySelector('[data-mobile-menu-toggle]');
				if (toggle) {
					toggle.setAttribute('aria-expanded', 'false');
				}
				document.body.classList.remove('mobile-menu-open');
			}

			if (formSection) {
				// Form exists on current page - scroll to it
				e.preventDefault();
				formSection.scrollIntoView({ behavior: 'smooth' });
			} else if (window.location.pathname !== '/') {
				// Form doesn't exist and we're not on home page - navigate to home
				e.preventDefault();
				window.location.href = '/#pap-form-section';
			}
			// If form exists within a link href or we're on home page, let natural link behavior occur
		});
	});
});

/**
 * HCP Gate Modal
 * Shows modal on click of header-top-left text
 */
document.addEventListener('DOMContentLoaded', function() {
	const hcpModal = document.getElementById('hcp-gate-modal');
	const goBackBtn = document.getElementById('hcp-go-back');
	const confirmBtn = document.getElementById('hcp-confirm');
	const COOKIE_NAME = 'hcp_acknowledged';
	const COOKIE_EXPIRY_DAYS = 365;
	const defaultDestinationUrl = 'https://papzimeoshcp.com';

	if (!hcpModal || !goBackBtn || !confirmBtn) {
		return;
	}

	// Helper function to set cookie
	function setCookie(name, value, days) {
		const date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		const expires = "expires=" + date.toUTCString();
		document.cookie = name + "=" + value + ";" + expires + ";path=/";
	}

	const triggers = document.querySelectorAll('.hcp-trigger');
	if (!triggers || triggers.length === 0) {
		return;
	}

	triggers.forEach((trigger) => {
		trigger.style.cursor = 'pointer';

		trigger.addEventListener('click', function(e) {
			e.preventDefault();

			const destinationUrl = (trigger.getAttribute('href') || defaultDestinationUrl).trim();
			confirmBtn.dataset.hcpUrl = destinationUrl;
			hcpModal.classList.add('is-visible');
		});
	});

	goBackBtn.addEventListener('click', function(e) {
		e.preventDefault();
		hcpModal.classList.remove('is-visible');
		delete confirmBtn.dataset.hcpUrl;
	});

	confirmBtn.addEventListener('click', function(e) {
		e.preventDefault();
		setCookie(COOKIE_NAME, 'true', COOKIE_EXPIRY_DAYS);

		const url = (confirmBtn.dataset.hcpUrl || defaultDestinationUrl).trim();
		hcpModal.classList.remove('is-visible');
		delete confirmBtn.dataset.hcpUrl;

		if (url) {
			window.open(url, '_blank', 'noopener');
		}
	});

	const backdrop = hcpModal.querySelector('.hcp-gate-modal-backdrop');
	if (backdrop) {
		backdrop.addEventListener('click', function() {
			hcpModal.classList.remove('is-visible');
			delete confirmBtn.dataset.hcpUrl;
		});
	}

	document.addEventListener('keydown', function(ev) {
		if (ev.key === 'Escape') {
			hcpModal.classList.remove('is-visible');
			delete confirmBtn.dataset.hcpUrl;
		}
	});
});

/**
 * Exit Leaving Modal
 * Shows a confirmation modal when clicking links/buttons marked `.exit-modal`.
 * Uses event delegation so dynamically rendered links (e.g. site locator cards) are included.
 */
document.addEventListener('DOMContentLoaded', function() {
	const exitModal = document.getElementById('exit-leaving-modal');
	const goBackBtn = document.getElementById('exit-leaving-go-back');
	const continueBtn = document.getElementById('exit-leaving-continue');

	if (!exitModal || !goBackBtn || !continueBtn) {
		return;
	}

	document.addEventListener('click', function(e) {
		const trigger = e.target.closest('.exit-modal');
		if (!trigger) {
			return;
		}

		const url = (trigger.getAttribute('href') || trigger.dataset.exitUrl || '').trim();

		// If we don't have a destination, don't block navigation.
		if (!url || url === '#') {
			return;
		}

		e.preventDefault();

		// Close mobile menu if open so the exit modal is visible.
		const mobileMenu = document.querySelector('[data-mobile-menu]');
		if (mobileMenu && mobileMenu.classList.contains('is-open')) {
			mobileMenu.classList.remove('is-open');
			const menuOverlay = document.querySelector('[data-mobile-menu-overlay]');
			if (menuOverlay) {
				menuOverlay.classList.remove('is-open');
			}
			const toggle = document.querySelector('[data-mobile-menu-toggle]');
			if (toggle) {
				toggle.setAttribute('aria-expanded', 'false');
			}
			document.body.classList.remove('mobile-menu-open');
		}

		continueBtn.dataset.exitUrl = url;
		exitModal.classList.add('is-visible');
	});

	goBackBtn.addEventListener('click', function(e) {
		e.preventDefault();
		exitModal.classList.remove('is-visible');
		delete continueBtn.dataset.exitUrl;
	});

	continueBtn.addEventListener('click', function(e) {
		e.preventDefault();
		const url = (continueBtn.dataset.exitUrl || '').trim();
		exitModal.classList.remove('is-visible');
		delete continueBtn.dataset.exitUrl;

		if (url) {
			window.open(url, '_blank', 'noopener');
		}
	});

	const backdrop = exitModal.querySelector('.exit-leaving-modal-backdrop');
	if (backdrop) {
		backdrop.addEventListener('click', function() {
			exitModal.classList.remove('is-visible');
			delete continueBtn.dataset.exitUrl;
		});
	}

	document.addEventListener('keydown', function(ev) {
		if (ev.key === 'Escape') {
			exitModal.classList.remove('is-visible');
			delete continueBtn.dataset.exitUrl;
		}
	});
});

/**
 * Registration Form - Submit Button Opacity
 * Apply opacity to submit button until all required fields are filled
 */
document.addEventListener('DOMContentLoaded', function() {
	const form = document.getElementById('omn-registration-form');
	const submitBtn = document.getElementById('omn-submit-btn');

	if (!form || !submitBtn) {
		return;
	}

	function validateForm() {
		// Get form field values
		const iama = document.querySelector('input[name="iama"]:checked');
		const fname = document.getElementById('fname').value.trim();
		const lname = document.getElementById('lname').value.trim();
		const email = document.getElementById('email').value.trim();
		const zipcode = document.getElementById('zipcode').value.trim();
		const terms = document.getElementById('terms').checked;

		// Check if all required fields are filled
		const allFilled = iama && fname && lname && email && zipcode && terms;

		// Update button opacity class
		if (!allFilled) {
			submitBtn.classList.add('is-incomplete');
		} else {
			submitBtn.classList.remove('is-incomplete');
		}
	}

	// Add event listeners to all form inputs
	const allInputs = form.querySelectorAll('input');
	allInputs.forEach(input => {
		input.addEventListener('change', validateForm);
		input.addEventListener('keyup', validateForm);
	});

	// Initial state - button opacity applied
	validateForm();
});

/**
 * Back to Top Button
 * Mobile-only button that scrolls page to top
 */
document.addEventListener('DOMContentLoaded', function() {
	const backToTopBtn = document.querySelector('.back-to-top');
	if (backToTopBtn) {
		backToTopBtn.addEventListener('click', function() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		});
	}
});

/**
 * Play SVG chart animations when they enter the viewport.
 */
document.addEventListener('DOMContentLoaded', function() {
	const charts = document.querySelectorAll('[data-animate-on-scroll]');
	if (!charts.length) {
		return;
	}

	const reveal = function(chart) {
		chart.classList.add('is-visible');
	};

	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	if (reduceMotion || !('IntersectionObserver' in window)) {
		charts.forEach(reveal);
		return;
	}

	const observer = new IntersectionObserver(function(entries, obs) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting) {
				reveal(entry.target);
				obs.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0.35
	});

	charts.forEach(function(chart) {
		chart.classList.add('is-pending');
		observer.observe(chart);
	});
});

/*Input field Phone number dash adding scritp - start*/
document.addEventListener('DOMContentLoaded', function () {
    const phone = document.getElementById('phone');

    if (!phone) return;

    phone.addEventListener('input', function () {
        let value = this.value.replace(/\D/g, '').substring(0, 12);

        if (value.length > 6) {
            value = value.substring(0, 3) + '-' +
                    value.substring(3, 6) + '-' +
                    value.substring(6);
        } else if (value.length > 3) {
            value = value.substring(0, 3) + '-' +
                    value.substring(3);
        }

        this.value = value;
    });
});
/*Input field Phone number dash adding scritp - end*/